import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Joi from "joi";
import { InputAdornment } from "@material-ui/core";
import { DialogComponent, Inputs } from "../../../../../../../Components";
import { GlobalTranslate } from "../../../../../../../Helper";

export const EditPSICommissionSlabDialog = ({
  parentTranslationPath,
  translationPath,
  isOpen,
  onClose,
  onSave,
  activeSlab,
  setSelected,
  dispatch,
  selected,
  slabIndex,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [isLoading, setIsLoading] = useState(false);
  const [helperText, setHelperText] = useState({
    rangeFrom: "",
  });

  const [slabInfo, setSlabInfo] = useState({
    id: null,
    rangeFrom: null,
    rangeTo: null,
    commissionPercentage: null,
  });
  const schema = Joi.object({
    rangeFrom: Joi.number()
      .required()
      .messages({
        "number.base": t(`${translationPath}from-is-required`),
        "number.empty": t(`${translationPath}from-is-required`),
        "number.required": t(`${translationPath}from-is-required`),
      }),

    commissionPercentage: Joi.number()
      .required()
      .messages({
        "number.base": t(`${translationPath}commission_percentage_required`),
        "number.empty": t(`${translationPath}commission_percentage_required`),
        "number.required": t(
          `${translationPath}commission_percentage_required`
        ),
      }),
  })
    .options({
      abortEarly: false,
      allowUnknown: true,
    })
    .validate(slabInfo);

  const saveHandler = async () => {
    let newList = selected.psiCommissionSlabs
      ? [...selected.psiCommissionSlabs]
      : [];
    if (slabInfo) {
      newList[slabIndex] = {
        ...newList[slabIndex],
        rangeFrom: slabInfo?.rangeFrom,
        rangeTo: slabInfo?.rangeTo,
        commissionPercentage: slabInfo?.commissionPercentage,
      };
    }
    setSelected({ ...selected, psiCommissionSlabs: newList });
    dispatch({ id: "psiCommissionSlabs", value: newList });
    onSave();
  };

  useEffect(() => {
    if (activeSlab) setSlabInfo({ ...activeSlab });
    else
      setSlabInfo({
        id: null,
        rangeFrom: 0,
        rangeTo: 0,
        commissionPercentage: 0,
      });
  }, [activeSlab]);

  useEffect(() => {
    if (!isOpen)
      setSlabInfo((item) => ({
        id: null,
        rangeFrom: 0,
        rangeTo: 0,
        commissionPercentage: 0,
      }));
  }, [isOpen]);

  return (
    <>
      <DialogComponent
        saveText={GlobalTranslate.t("Shared:confirm")}
        disableBackdropClick
        titleText={t(`edit_slab`)}
        saveClasses={"btns theme-solid bg-primary"}
        saveType="button"
        maxWidth="sm"
        dialogContent={
          <div className="d-flex-column-center">
            <div
              className={`w-100 d-flex d-inline-flex d-flex-v-center-h-between px-2`}
              key={`a-less-than`}
            >
              <div className={`w-33 px-2`}>
                <Inputs
                  labelValue={"from"}
                  labelClasses="Requierd-Color"
                  wrapperClasses={"theme-form-builder"}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  inputPlaceholder={"enter_from_less_than_to"}
                  min={0}
                  value={slabInfo?.rangeFrom || 0}
                  type={"number"}
                  onInputChanged={(e) => {
                    let { value } = e.target;
                    if (value < 0) value = value * -1;

                    setSlabInfo((range) => ({
                      ...range,
                      rangeFrom: value,
                    }));
                    // if (value === "" || !value)
                    //   setHelperText("enter_from_less_than_to");
                    // else setHelperText("");
                  }}
                  withNumberFormat
                  endAdornment={
                    <InputAdornment position="start" className="px-2">
                      AED
                    </InputAdornment>
                  }
                  // isWithError
                  // error={getErrorByName(schema, "rangeFrom").error}
                  // helperText={getErrorByName(schema, "rangeFrom").message}
                  // isSubmitted={isSubmitted}
                />
              </div>
              <div className={`w-33 px-2`}>
                <Inputs
                  labelValue={"to"}
                  wrapperClasses={"theme-form-builder"}
                  parentTranslationPath={parentTranslationPath}
                  inputPlaceholder={"enter_to_greater_than_from"}
                  min={0}
                  value={slabInfo?.rangeTo || 0}
                  type={"number"}
                  onInputChanged={(e) => {
                    let { value } = e.target;
                    if (value < 0) value = value * -1;
                    setSlabInfo((range) => ({
                      ...range,
                      rangeTo: value,
                    }));
                  }}
                  withNumberFormat
                  endAdornment={
                    <InputAdornment position="start" className="px-2">
                      AED
                    </InputAdornment>
                  }
                />
              </div>
              <div className={`w-33 px-2`}>
                <Inputs
                  labelValue={"commission"}
                  labelClasses="Requierd-Color"
                  wrapperClasses={"theme-form-builder"}
                  parentTranslationPath={parentTranslationPath}
                  inputPlaceholder={"enter_commission_percentage"}
                  min={0}
                  value={slabInfo?.commissionPercentage || 0}
                  type={"number"}
                  onInputChanged={(e) => {
                    let { value } = e.target;
                    if (value > 100) value = 100;
                    else if (value < 0) value = value * -1;

                    setSlabInfo((range) => ({
                      ...range,
                      commissionPercentage: value,
                    }));
                  }}
                  withNumberFormat
                  endAdornment={
                    <InputAdornment position="start" className="px-2">
                      %
                    </InputAdornment>
                  }
                />
              </div>
            </div>
          </div>
        }
        isOpen={isOpen}
        saveIsDisabled={
          !slabInfo.rangeFrom ||
          !slabInfo.commissionPercentage
        }
        onSaveClicked={() => saveHandler()}
        onCancelClicked={onClose}
        translationPath={translationPath}
      />
    </>
  );
};
